module.exports = __webpack_public_path__ + "img/shadow_average_mask.2125d871.png";